export const listOfRoomNamesForNewServers: string[] = ['642-1', '450-604'] //не работает
export const listOfRoomNamesForOldServers: string[] = ['245-1', '1108-703', '1152-743', '1151-742', '442-149', '81-138']

// 334 - Proofix
// 639 - Федеральная Палата Адвокатов РФ
// 634 - Телекор
// 646 - Корона
// 608 - Warmmet
// 649 - Мастерская смыслов
// 653 - Art me up
// 654 - Найди себя
// 657 - Мунвит
// 610 - HR 3.0 Академия вертикального роста
// 588 - ИП Расюк
// 743 - Битбанкер
// 742 - Райтек
 //не работает
export const listOfOrganizationIdsForNewServers: string[] = [ //не работает
  '334',
  '639',
  '634',
  '646',
  '608',
  '649',
  '653',
  '654',
  '657',
  '610',
  '588',
  '743',
  '742'
]

export const EServerApplication = {
  voiceAssistant: 'voice_assistant',
  voiceAssistant2: 'voice_assistant_2',
  textAssistant: 'text_assistant',
  sip: 'sip',
  meet: 'meet',
} as const

export const enum ESpecificUsernames {
  'Recorder' = 'Recorder',
  'Guest' = 'Guest',
}

export const enum ESpecificErrors {
  'Camera already used in another app' = 'Device in use',
}

export const specificPaths = ['/egress/', '/director/', '/media-streamer/', '/guest/']

export const enum ETopics {
  'chat' = 'chat-topic',
}

export const ORGANIZER_CODE_FOR_SAMOLET_PROJECT = '123456'
